import styled from 'styled-components'

export const ThanksEmbedSection = styled.div`
  margin-top: 20px;
`

export const ThanksEmbedContainer = styled.div`
  width: 100%;
  min-height: 1px;
`

export const ThanksDevPreviewCard = styled.div`
  border: 1px solid #d5e3ff;
  background: #f5f9ff;
  border-radius: 8px;
  padding: 16px;
  color: #1f2a44;
`

export const ThanksDevPreviewTitle = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 700;
`

export const ThanksDevPreviewDescription = styled.p`
  margin: 8px 0 0;
  font-size: 13px;
  line-height: 1.4;
`

export const ThanksDevPreviewOfferList = styled.ul`
  margin: 12px 0 0;
  padding-left: 18px;
`

export const ThanksDevPreviewOfferItem = styled.li`
  margin-top: 4px;
`
